export default "__VITE_ASSET__CiHx67qj__"